import React, { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCandidateStatus } from "../../../features/Recruiter/RecruiterReports/candidateListSlice";
import StatusChip, {
  getStatusChipColor,
} from "../../../components/common/StatusChip/StatusChip";
import { LoadingButton } from "../../../components/common/LoadingButton";
import useConfirmationDialog from "../../../hooks/useConfirmationDialog";
import { ConfirmationDialog } from "../../../components/common/Dialog";
import { deleteCandidate } from "../../../features/Candidate/candidateStatusSlice";

const UpdateCandidateStatusButton = ({
  row,
  getHiredCandidatesReportClient,
  page,
}) => {
  const { _id, user_id, candidate_status } = row;
  const {
    open,
    handleOpenDialog,
    handleCloseDialog,
    handleConfirmAction,
    isLoading,
    currentAction,
  } = useConfirmationDialog();

  const handleUpdateStatus = async () => {
    const data = {
      userid: user_id,
      status: candidate_status === "inactive" ? "active" : "inactive",
      usertype: "recruiter",
      candidateid: _id?.$oid,
    };
    handleConfirmAction(updateCandidateStatus, data, () =>
      getHiredCandidatesReportClient("", page)
    );
  };

  return (
    <>
      <LoadingButton
        color={getStatusChipColor(row.candidate_status)}
        isLoading={isLoading}
        onClick={() => handleOpenDialog("updateCandidateStatus")}
      >
        {row.candidate_status}
      </LoadingButton>
      <ConfirmationDialog
        open={open}
        onClose={handleCloseDialog}
        currentAction={currentAction}
        onConfirm={handleUpdateStatus}
        loading={isLoading}
        candidateStatus={
          candidate_status === "inactive" ? "active" : "inactive"
        }
      />
    </>
  );
};

export default memo(UpdateCandidateStatusButton);
